import { setup } from "web/entrypoints/common/setup";
import "./css-editorial";
import { editorialComponents } from "./editorial";

setup(editorialComponents);
